import DeskPlanPage from "@/pages/comp/edu/desk/desk_plan";
import DiscoverMapListPage from "@/pages/comp/edu/discover_map/list";
import DiscoverMapHistoryPage from "@/pages/comp/edu/discover_map/history_list";
import DiscoverMapListCalendarPage from "@/pages/comp/edu/discover_map/list_calendar";
import DailyPrescribeHistoryPage from "@/pages/comp/edu/daily_prescribe/history";

const routerArr:object[] = [
  {
    path: "/comp/edu/desk/desk_plan",
    element: <DeskPlanPage></DeskPlanPage>,
  },
  {
    path: "/comp/edu/discover_map/list",
    element: <DiscoverMapListPage></DiscoverMapListPage>,
  },
  {
    path: "/comp/edu/discover_map/history_list",
    element: <DiscoverMapHistoryPage></DiscoverMapHistoryPage>,
  },
  {
    path: "/comp/edu/discover_map/list_calendar",
    element: <DiscoverMapListCalendarPage></DiscoverMapListCalendarPage>,
  },
  {
    path: "/comp/edu/daily_prescribe/history",
    element: <DailyPrescribeHistoryPage></DailyPrescribeHistoryPage>,
  },
];

export default routerArr;